import { HistoryLogsPanel } from "@/components/organisms";

export const HistoryLogs = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <HistoryLogsPanel />
    </div>
  );
};
